import { api } from '@/modules/shared/lib/axios'

import type { TCustomerFormCnpj } from '../types/client-form-promise-cnpj.type'

export type TCustomerFormLoadCnpjService = {
	payload: {
		cnpj: string
	}
}

const ensureValidCnpjResponse = (
	data: TCustomerFormCnpj,
): TCustomerFormCnpj => {
	if (!data?.codigo_municipio_ibge) {
		throw new Error('Resposta da consulta de CNPJ incompleta.')
	}

	return data
}

export const customerFormLoadCnpjService = async ({
	payload,
}: TCustomerFormLoadCnpjService): Promise<TCustomerFormCnpj> => {
	const response = await api.get<TCustomerFormCnpj>(
		`consultaminhareceita/${payload.cnpj}`,
	)

	return ensureValidCnpjResponse(response.data)
}

export const customerFormLoadCnpjaService = async ({
	payload,
}: TCustomerFormLoadCnpjService): Promise<TCustomerFormCnpj> => {
	const response = await api.get<TCustomerFormCnpj>(`consultacnpja/${payload.cnpj}`)

	return ensureValidCnpjResponse(response.data)
}
